import React, { useState } from "react";
import { observer } from "mobx-react";
import Select, { components } from "react-select";
import { Checkbox } from "react-bootstrap";
import { MULTISEARCH_USAGE } from "src/stores/MultiSearchStore/MultiSearchStore";
import EnvironmentUtils from "src/utils/EnvironmentUtils";

@observer
export class MultiSearchVariableListItem extends React.Component {
  handleSelectChange = (selectedOptions, usage) => {
    let newArray = [];
    if (usage === MULTISEARCH_USAGE.ADVANCED_SEARCH) {
      if (selectedOptions?.length > 0) {
        newArray = selectedOptions.map((option) => {
          return {
            objectId: option.value,
            isIgnored: option.isIgnored ?? false,
            mustMatch: option.mustMatch ?? false,
          };
        });
      }
      this.props.onUpdateEnumeratedList(newArray, this.props.variableTid);
    }
  };

  render() {
    const { label, enumeratedItems, values, usage } = this.props;
    return (
      <React.Fragment>
        <div
          className={
            EnvironmentUtils.isBirdApp()
              ? "item-text item-text-bird"
              : "item-text"
          }
        >
          {label}
        </div>
        {enumeratedItems && enumeratedItems.length > 0 && (
          <SelectEnumerated
            options={enumeratedItems.map((item) => ({
              label: `${item.name} (${item.code})`,
              value: item.id,
              mustMatch: item?.properties?.get("MUST_MATCH"),
              isIgnored: item?.properties?.get("SHOULD_BE_IGNORED"),
              fullItem: item,
            }))}
            values={
              values?.map((item) => ({
                label: `${
                  item?.properties?.get("MUST_MATCH") ? "[Must] " : ""
                }${item.name} (${item.code})`,
                value: item.id,
                mustMatch: item?.properties?.get("MUST_MATCH"),
                isIgnored: item?.properties?.get("SHOULD_BE_IGNORED"),
                fullItem: item,
              })) || []
            }
            onChange={(selectedValues) =>
              this.handleSelectChange(selectedValues, usage)
            }
            handleSelectChange={(selectedValues) =>
              this.handleSelectChange(selectedValues, usage)
            }
            usage={usage}
            onBlur={
              usage === MULTISEARCH_USAGE.NAVIGATOR_COMPONENT
                ? this.props.executeQueryCallback
                : undefined
            }
          />
        )}
      </React.Fragment>
    );
  }
}

const Option = (props) => {
  const [isIgnored, setIsIgnored] = useState(props.data.isIgnored ?? false);
  const [mustMatch, setMustMatch] = useState(props.data.mustMatch ?? false);

  const usage = props.usage;

  const onChangeIgnore = (e) => {
    e.stopPropagation();
    if (mustMatch) {
      e.preventDefault();
      return;
    } else {
      const newIsIgnored = !isIgnored;
      props.data.isIgnored = newIsIgnored;
      setIsIgnored(newIsIgnored);

      if (!props.data.fullItem.properties) {
        props.data.fullItem.properties = new Map();
      }
      props.data.fullItem.properties.set("SHOULD_BE_IGNORED", newIsIgnored);

      const updatedSelectedOptions = [
        ...props.getSelectedOptions(),
        {
          label: props.data.label,
          value: props.data.value,
          mustMatch: props.data.mustMatch,
          isIgnored: newIsIgnored,
        },
      ];

      props.handleSelectChange(updatedSelectedOptions, props.usage);
    }
  };

  const onChangeMustMatch = (e) => {
    e.stopPropagation();
    if (isIgnored) {
      e.preventDefault();
      return;
    } else {
      const newMustMatch = !mustMatch;
      props.data.mustMatch = newMustMatch;
      setMustMatch(newMustMatch);

      if (!props.data.fullItem.properties) {
        props.data.fullItem.properties = new Map();
      }
      props.data.fullItem.properties.set("MUST_MATCH", newMustMatch);

      const updatedSelectedOptions = [
        ...props.getSelectedOptions(),
        {
          label: props.data.label,
          value: props.data.value,
          mustMatch: newMustMatch,
          isIgnored: props.data.isIgnored,
        },
      ];

      props.handleSelectChange(updatedSelectedOptions, props.usage);
    }
  };

  return (
    <>
      <components.Option {...props}>
        <div
          style={{
            color: "black",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "70%" }}>{props.children}</div>
          {!EnvironmentUtils.isBirdApp() && (
            <div
              style={{ width: "25%", display: "flex", flexDirection: "column" }}
            >
              {usage !== MULTISEARCH_USAGE.ADVANCED_SEARCH && (
                <Checkbox
                  size="small"
                  checked={isIgnored}
                  onChange={(e) => onChangeIgnore(e)}
                  onClick={(e) => e.stopPropagation()}
                >
                  Ignore
                </Checkbox>
              )}

              <Checkbox
                size="small"
                checked={mustMatch}
                onChange={(e) => onChangeMustMatch(e)}
                onClick={(e) => e.stopPropagation()}
              >
                Must match
              </Checkbox>
            </div>
          )}
        </div>
      </components.Option>
    </>
  );
};

const SelectEnumerated = ({
  onChange,
  onBlur,
  onFocus,
  options,
  values,
  disabled,
  usage,
  handleSelectChange,
}) => {
  let placeholder;
  if (disabled) {
    placeholder = "Disabled...";
  } else if (usage === MULTISEARCH_USAGE.NAVIGATOR_COMPONENT) {
    const areSomeConfigOptionsCheckedOption = options.some(
      (option) => option.isIgnored === true || option.mustMatch === true
    );
    placeholder = areSomeConfigOptionsCheckedOption
      ? "Custom match"
      : "All members are matched";
  } else {
    placeholder = "Choose values...";
  }

  return (
    <div className="select-enumerated">
      <Select
        controlShouldRenderValue={usage === MULTISEARCH_USAGE.ADVANCED_SEARCH}
        closeMenuOnSelect={false}
        isDisabled={disabled}
        isMulti
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        options={options}
        isClearable={usage === MULTISEARCH_USAGE.ADVANCED_SEARCH}
        placeholder={placeholder}
        value={usage === MULTISEARCH_USAGE.NAVIGATOR_COMPONENT ? [] : values}
        components={{
          Option: (props) => (
            <Option
              {...props}
              usage={usage}
              handleSelectChange={handleSelectChange}
              getSelectedOptions={() => values}
            />
          ),
        }}
      />
    </div>
  );
};
